<template>
  <section id="container">
    <div class="title_wrap">
      <h1>최초 로그인</h1></div>
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>회원정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd><label>성명 <span class="forg">*</span></label>
            <ul>
              <li>{{ userInfo.userNm }}</li>
            </ul>
          </dd>
          <dd><label>회사 <span class="forg">*</span></label>
            <ul>
              <li>{{ userInfo.cmpyNm }}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd><label>ID <span class="forg">*</span></label>
            <ul>
              <li>{{ userInfo.userId }}</li>
            </ul>
          </dd>
          <dd><label>이메일 <span class="forg">*</span></label>
            <ul>
              <li class="email_auth_row">
                <span class="email_text">{{ userInfo.email }}</span>
                <button
                    type="button"
                    class="mid_btn"
                    @click="sendEmailAuth"
                    :disabled="emailVerified || (authSent && timerSeconds > 0)"
                >{{ authSent && !emailVerified ? '인증번호 재전송' : '인증번호 전송' }}</button>
              </li>
              <li v-if="authSent && !emailVerified" class="email_code_row">
                <div class="email_code_box" :class="{ 'is_expired': timerSeconds <= 0 }">
                  <input
                      type="text"
                      class="email_code_input"
                      v-model="authNumber"
                      maxlength="4"
                      placeholder="인증번호 4자리 입력"
                      :disabled="emailVerified"
                  />
                  <span v-if="timerSeconds > 0" class="email_code_timer">{{ timerDisplay }}</span>
                </div>
                <button type="button" class="mid_btn orange" @click="confirmEmailAuth" :disabled="emailVerified || timerSeconds <= 0">인증확인</button>
              </li>
              <li class="email_msg" v-show="authSent" style="margin-top:0px; margin-bottom: 10px;">
                <span v-if="emailVerified" class="msg_green">
                  <span class="k-icon k-i-check-circle"></span>이메일 인증이 완료되었습니다.
                </span>
                <span v-else-if="authSent && timerSeconds > 0" class="msg_info">
                  인증번호가 발송되었습니다. 메일을 확인 후 입력해 주세요.
                </span>
                <span v-else-if="authSent && timerSeconds <= 0" class="msg_red">
                  유효시간이 초과하였습니다. 재전송해 주세요.
                </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd><label>비밀번호 <span class="forg">*</span></label>

            <ul>
              <li>
                <kendo-maskedtextbox
                    ref="newPasswordRef"
                    name="newPassword"
                    @change="newPwKeyUp"
                    class="join_msg w80"
                    maxlength="50"
                    type="password"
                    :value="defaultPassword"
                >
                </kendo-maskedtextbox>
                <div class="join_msg" v-html="passwordComfirmMsg"></div>
              </li>
            </ul>
          </dd>
          <dd><label>비밀번호 재입력 <span
              class="forg">*</span></label>
            <kendo-maskedtextbox
                ref="newPasswordConfirmRef"
                name="newPasswordConfirm"
                class="w40"
                @change="newPwConfirmKeyUp"
                maxlength="50"
                type="password"
                :value="defaultPassword"
            >
            </kendo-maskedtextbox>
            <div class="join_msg" v-html="passwordCheckComfirmMsg"></div>
          </dd>
        </li>
      </ul>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap"><h2>약관 동의</h2></div>
      <div class="join_agree_wrap">
        <div class="gcheck">
          <label>
            <input
                type="checkbox"
                id="agree_all"
                class="k-checkbox"
                v-model="allSelected"
                @click="selectAll"
            >
            <label for="agree_all" class="k-checkbox-label"></label>
          </label>
          <div class="diblock ml5">모두 동의합니다.</div>
        </div>
        <div class="allcheck_txt"> 전체동의는 필수 및 선택정보에 대한 동의도 포함되어 있으며, 개별적으로도 동의를 선택하실 수 있습니다.
          <br> 선택항목에 대한 동의를 거부하시는 경우에도 서비스는 이용이 가능합니다.
        </div>
        <div class="agree_list">
          <ul>
            <li class="agree_tit">
              <label>
                <input
                    type="checkbox"
                    id="agree01"
                    class="k-checkbox"
                    v-model="clsAgrYn"
                    @change="updateCheckCls"
                >
                <label class="k-checkbox-label" for="agree01"></label>
              </label>
              <div class="diblock ml5">
                <a @click="popup('serviceTerms')" style="cursor: pointer">
                  [필수] ES KIOSK 이용약관
                  <span class="k-icon k-i-arrow-chevron-right"></span>
                </a>
              </div>
            </li>
            <li class="agree_tit">
              <label>
                <input
                    type="checkbox"
                    id="agree02"
                    class="k-checkbox"
                    v-model="psiAgrYn"
                    @change="updateCheckPsi"
                >
                <label class="k-checkbox-label" for="agree02"></label>
              </label>
              <div class="diblock ml5">
                <a @click="popup('privacy')" style="cursor: pointer">
                  [필수] ES KIOSK 개인정보 활용 동의
                  <span class="k-icon k-i-arrow-chevron-right"></span>
                </a>
              </div>
            </li>
            <li class="agree_tit">
              <label>
                <input
                    type="checkbox"
                    id="agree03"
                    class="k-checkbox"
                    v-model="mktAgrYn"
                    @change="updateCheckMkt"
                />
                <label class="k-checkbox-label" for="agree03"></label>
              </label>
              <div class="diblock ml5">
                <a @click="popup('marketing')" style="cursor: pointer">
                  [선택] 마케팅 활용 동의
                  <span class="k-icon k-i-arrow-chevron-right"></span>
                </a>
              </div>
              <div class="agree_option mgl20">
                <label>
                  <input
                      type="checkbox"
                      id="agree04"
                      class="k-checkbox"
                      v-model="mktEmailAgrYn"
                      @change="updateCheckMktEmail"
                  />
                  <label class="k-checkbox-label" for="agree04"></label>
                </label>
                <div class="diblock ml5 mr10">
                  <a>E-mail</a>
                </div>
                <label>
                  <input
                      type="checkbox"
                      id="agree05"
                      class="k-checkbox"
                      v-model="mktSmsAgrYn"
                      @change="updateCheckMktSms"
                  />
                  <label class="k-checkbox-label" for="agree05"></label>
                </label>
                <div class="diblock ml5">
                  <a>SMS</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="button_area">
      <ul>
        <li>
          <button class="large_btn" @click="logoutProcess()">로그아웃</button>
        </li>
        <li>
          <button id="buttonSubmit" @click="onClickSave" class="large_btn orange">저장하기</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import EtnersEncDecUtil from '@/common/etners.encDec.util'
import EtnersPasswordUtil from '@/common/etners.password.util'

export default {
  name: 'FirstLoginForm',
  data() {
    const sessionLoginUserData = sessionStorage.getItem('loginUserData')
    const userInfo = JSON.parse(sessionLoginUserData)
    const publicKey = this.$store.state.encStoreModule.enc.data
    return {
      publicKey: publicKey,
      userInfo: userInfo,
      allSelected: false, // 약관동의 모두 선택
      clsAgrYn: false, // 이용약관
      psiAgrYn: false, // 개인정보 활용동의
      mktAgrYn: false, // 마케팅 활용동의
      mktEmailAgrYn: false,
      mktSmsAgrYn: false,
      validateCheck: false,
      passwordCheckComfirmMsg: '<span class="msg_green"></span>',
      passwordComfirmMsg: null,
      defaultPassword: "",
      authNumber: '',
      authSent: false,
      emailVerified: false,
      authTimer: null,
      authExpireAt: 0,
      timerSeconds: 0,
    }
  },
  computed: {
    timerDisplay () {
      const min = Math.floor(this.timerSeconds / 60)
      const sec = this.timerSeconds % 60
      return `${min}:${String(sec).padStart(2, '0')}`
    }
  },

  mounted () {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },

  beforeDestroy () {
    if (this.authTimer) {
      clearInterval(this.authTimer)
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },

  methods: {
    /** 비밀번호 **/
    /***비밀번호 정책 주석처리*****/
    newPwKeyUp: function (e) {
      // const matched = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/.test(e.sender.value())
      const newPasswordConfirm = this.$refs.newPasswordConfirmRef.kendoWidget().value()
      if (EtnersPasswordUtil.combinationPwd(e.sender.value())) {
        this.validateCheck = false
        this.passwordComfirmMsg = '<span class="msg_red">비밀번호는 8자 이상의 문자,숫자,특문으로 작성해주세요.</span>'
      } else if (!EtnersPasswordUtil.combinationPwd(e.sender.value()) && (newPasswordConfirm === e.sender.value())) {
        this.validateCheck = true
        this.passwordComfirmMsg = '<span class="msg_green"></span>'
      } else {
        this.passwordComfirmMsg = '<span class="msg_green"></span>'
      }

      if ((newPasswordConfirm !== e.sender.value()) && newPasswordConfirm.length != 0) {
        this.validateCheck = false
        this.passwordCheckComfirmMsg = '<span class="msg_red">입력한값이 일치하지 않습니다.</span>'
      } else {
        this.validateCheck = true
        this.passwordCheckComfirmMsg = '<span class="msg_red"></span>'
      }
    },
    /***비밀번호 정책 주석처리*****/
    newPwConfirmKeyUp: function (e) {
      const newPassword = this.$refs.newPasswordRef.kendoWidget().value()

      if (newPassword !== e.sender.value()) {
        this.validateCheck = false
        this.passwordCheckComfirmMsg = '<span class="msg_red">입력한 값이 일치하지 않습니다.</span>'
      } else if (newPassword == e.sender.value()) {
        this.passwordCheckComfirmMsg = '<span class="msg_green">입력한 값이 일치합니다.</span>'
        this.validateCheck = true
      } else if (newPassword == e.sender.value()) {
        this.passwordCheckComfirmMsg = '<span class="msg_green">입력한 값이 일치합니다.</span>'
        this.validateCheck = true
      } else {
        this.passwordCheckComfirmMsg = '<span class="msg_green"></span>'
      }
    },

    selectAll: function (e) {
      if(e.target.checked){
        this.allSelected = this.clsAgrYn = this.psiAgrYn = this.mktAgrYn = this.mktEmailAgrYn = this.mktSmsAgrYn = true
      } else {
        this.allSelected = this.clsAgrYn = this.psiAgrYn = this.mktAgrYn = this.mktEmailAgrYn = this.mktSmsAgrYn = false
      }
    },

    updateCheckCls: function (e) {
       this.clsAgrYn = e.target.checked
      if(!this.clsAgrYn){
        this.allSelected = false
      }else if(this.psiAgrYn && this.mktAgrYn){
        this.allSelected = true
      }
    },

    updateCheckPsi: function (e) {
      this.psiAgrYn = e.target.checked
      if(!this.psiAgrYn){
        this.allSelected = false
      }else if(this.clsAgrYn && this.mktAgrYn){
        this.allSelected = true
      }
    },

    updateCheckMkt: function (e) {
      this.mktAgrYn = this.mktEmailAgrYn = this.mktSmsAgrYn = e.target.checked
      if(!this.mktAgrYn){
        this.allSelected = false
      }else if(this.psiAgrYn && this.clsAgrYn){
        this.allSelected = true
      }
    },

    updateCheckMktEmail: function (e) {
      this.mktEmailAgrYn = e.target.checked
      if(!this.mktEmailAgrYn){
        this.allSelected = this.mktAgrYn = false
      }else if(this.mktEmailAgrYn && this.mktSmsAgrYn){
        this.mktAgrYn = true
        if(this.clsAgrYn && this.psiAgrYn && this.mktAgrYn){
          this.allSelected = true
        }
      }
    },

    updateCheckMktSms: function (e) {
      this.mktSmsAgrYn = e.target.checked
      if(!this.mktSmsAgrYn){
        this.allSelected = this.mktAgrYn = false
      }else if(this.mktEmailAgrYn && this.mktSmsAgrYn){
        this.mktAgrYn = true
        if(this.clsAgrYn && this.psiAgrYn && this.mktAgrYn){
          this.allSelected = true
        }
      }
    },

    sendEmailAuth: async function () {
      const vm = this
      if (vm.authTimer) {
        clearInterval(vm.authTimer)
        vm.authTimer = null
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/sendFirstLoginAuthNumber.json`
      const userIdRSA = await EtnersEncDecUtil.encryptRSA(vm.userInfo.userId, vm.publicKey)
      const param = {
        userId: userIdRSA,
        loginUserToken: sessionStorage.getItem('loginUserToken'),
        transferMethod: 'email',
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        kendo.alert('인증번호가 전송되었습니다. 유효시간은 1분 30초입니다.')
        vm.authSent = true
        vm.emailVerified = false
        vm.authNumber = ''
        vm.startTimer()
      })
    },

    confirmEmailAuth: async function () {
      const vm = this
      if (!vm.authNumber || vm.authNumber.length !== 4) {
        kendo.alert('인증번호 4자리를 입력해 주세요.')
        return false
      }
      if (vm.timerSeconds <= 0) {
        kendo.alert('인증번호 유효시간이 만료되었습니다. 다시 전송해 주세요.')
        return false
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/confirmAuthNumber.json`
      const userIdRSA = await EtnersEncDecUtil.encryptRSA(vm.userInfo.userId, vm.publicKey)
      const param = {
        authNumber: vm.authNumber,
        userId: userIdRSA,
      }
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        vm.emailVerified = true
        clearInterval(vm.authTimer)
        vm.authTimer = null
        kendo.alert('이메일 인증이 완료되었습니다.')
      })
    },

    startTimer: function () {
      const vm = this
      if (vm.authTimer) {
        clearInterval(vm.authTimer)
        vm.authTimer = null
      }
      vm.authExpireAt = Date.now() + 90 * 1000
      vm.tickTimer()
      vm.authTimer = setInterval(vm.tickTimer, 500)
    },

    tickTimer: function () {
      const vm = this
      const remaining = Math.max(0, Math.ceil((vm.authExpireAt - Date.now()) / 1000))
      vm.timerSeconds = remaining
      if (remaining <= 0 && vm.authTimer) {
        clearInterval(vm.authTimer)
        vm.authTimer = null
      }
    },

    handleVisibilityChange: function () {
      if (!document.hidden && this.authTimer) {
        this.tickTimer()
      }
    },

    onClickSave: async function () {
      const vm = this
      const refs = vm.$refs
      const userPwd = vm.$refs.newPasswordRef.kendoWidget().value().trim()
      const userPwdConfirm = vm.$refs.newPasswordConfirmRef.kendoWidget().value().trim()

      // const matched = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/.test(userPwd)
      // /** 비밀번호 확인**/
      // if (!matched) {
      //   kendo.alert('비밀번호는 8자 이상의 문자,숫자,특문으로 작성해주세요.')
      //   return
      // }
      // if (userPwd !== userPwdConfirm) {
      //   kendo.alert('비밀번호가 일치하지 않습니다.')
      //   return false
      // }
      // if (!vm.validateCheck || EtnersCommonUtil.isEmpty(userPwd) || EtnersCommonUtil.isEmpty(userPwdConfirm)) {
      //   kendo.alert('비밀번호를 확인해 주세요.</br> <span class="forg">*표시된 값은 필수 값입니다.</br>입력 후 저장해주세요. </span>')
      //   return false
      // }

      /** 이메일 인증 확인 **/
      if (!vm.emailVerified) {
        kendo.alert('이메일 인증을 완료해 주세요.')
        return false
      }

      /** 비밀번호 확인**/
      const value = EtnersPasswordUtil.validation(userPwd, userPwdConfirm)
      if (!value) {
        return false
      }

      /** 필수동의 확인**/
      if (vm.clsAgrYn === false || vm.psiAgrYn === false) {
        kendo.alert('필수 약관 동의를 확인해 주세요.')
        return false
      }

      // 평문을 RSA 공개키로 암호화
      let userPwdRSA = await EtnersEncDecUtil.encryptRSA(userPwd, vm.publicKey)

      kendo.confirm('사용자 정보를 등록하시겠습니까?').done(function () {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/saveFirstLogin.json`
        const param = {
          loginUserToken: sessionStorage.getItem('loginUserToken'),
          userPwd: userPwdRSA,
          clsAgrYn: vm.clsAgrYn ? 'Y' : 'N',
          psiAgrYn: vm.psiAgrYn ? 'Y' : 'N',
          mktEmailAgrYn: vm.mktEmailAgrYn ? 'Y' : 'N',
          mktSmsAgrYn: vm.mktSmsAgrYn ? 'Y' : 'N',
        }

        ApiUtil.post(url, param).then(async response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }

          kendo.alert('등록되었습니다.')
          sessionStorage.setItem('isFirstLogin', 'N')

          // === 이미 2차 인증을 통과한 토큰(mfa=Y)으로 진입 진행 ===
          // 최초 로그인 저장(saveFirstLogin)은 mfa=Y 토큰으로만 처리되므로,
          // 재로그인(login.json) 없이 기존 토큰으로 firstAccessInfo 를 호출한다.
          const loginUserToken = sessionStorage.getItem('loginUserToken')
          const firstAccessParams = {
            loginUserToken: loginUserToken,
            wmGbn: '01',
          }

          ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/firstAccessInfo.json`, firstAccessParams).then(function (response) {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
              return false
            }

            if (response.data.resultStatus.messageCode !== '2000') {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }
            /**
             * firstAccessInfo 데이터 가져온 시점
             */
            let firstAccessInfoResultData = response.data.resultData
            const isFirstLogin = firstAccessInfoResultData.isFirstLogin

            sessionStorage.setItem('loginUserToken', loginUserToken)
            sessionStorage.setItem('isFirstLogin', isFirstLogin)
            sessionStorage.setItem('loginUserData', JSON.stringify(firstAccessInfoResultData))

            vm.$router.push({
              name: 'Main'
            }).catch(() => {
              // Redirected Error 방지용 catch
            })
          })
        })
      })
    },

    popup: function (fileNm) {
      if (fileNm === 'privacy') {
        window.open("https://etners.com/terms/management/detail/27/02")
      } else if (fileNm === 'serviceTerms'){
        window.open("https://etners.com/terms/management/detail/27/01")
      } else {
        window.open('http://www.etners.com/privacy/esai/' + fileNm + '.html', '_blank')
      }
    },

    logoutProcess: function () {
      kendo.confirm('로그아웃하시겠습니까?').done(function () {
        sessionStorage.clear()
        setTimeout(function () {
          window.location.href = '/login'
        }, 300)
      })
    }
  }
}
</script>
<style scoped>
#container {
  padding-top: 50px;
}

/* 이메일 인증 영역 */
.email_auth_row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.email_text {
  font-size: 14px;
  color: #333;
}
.email_code_row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.email_code_box {
  display: inline-flex;
  align-items: center;
  width: 240px;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.15s linear, box-shadow 0.15s linear;
}
.email_code_box:focus-within {
  border-color: #fe5f40;
  box-shadow: 0 0 0 3px rgba(254, 95, 64, 0.12);
}
.email_code_box.is_expired {
  border-color: #e74c3c;
  background: #fff7f5;
}
.email_code_input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  height: 100%;
  font-size: 14px;
  letter-spacing: 4px;
  color: #333;
  padding: 0;
}
.email_code_input::placeholder {
  letter-spacing: 0;
  color: #a0a0a0;
}
.email_code_input:disabled {
  color: #999;
}
.email_code_timer {
  margin-left: 8px;
  font-size: 13px;
  color: #fe5f40;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.email_msg {
  margin-top: 6px;
  padding-top: 0;
  line-height: 1.5;
}
.email_msg .msg_green {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #2e8b57;
  font-size: 13px;
}
.email_msg .msg_green .k-icon {
  font-size: 16px;
}
.email_msg .msg_red {
  color: #e74c3c;
  font-size: 13px;
}
.email_msg .msg_info {
  color: #4d4d4d;
  font-size: 13px;
}
</style>
